import React, { memo } from 'react';

const MobileSms = ({ ...props }) => {
    return (
        <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.55 0c1.491 0 2.7 1.194 2.7 2.667v34.666c0 1.473-1.209 2.667-2.7 2.667h-17.1c-1.491 0-2.7-1.194-2.7-2.667V2.667C8.75 1.194 9.959 0 11.45 0h17.1zM20 34.93c-1.243 0-2.25.996-2.25 2.223 0 1.227 1.007 2.222 2.25 2.222s2.25-.995 2.25-2.222c0-1.227-1.007-2.222-2.25-2.222zm0 .741c.828 0 1.5.664 1.5 1.482a1.49 1.49 0 01-1.5 1.481 1.49 1.49 0 01-1.5-1.481A1.49 1.49 0 0120 35.67zM30 4.375H10v30h20v-30zm-8.125-2.5H17.5V2.5h4.375v-.625z"
                fill="#A9B1B9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26 7.5H14c-.825 0-1.492.675-1.492 1.5L12.5 22.5l3-3H26c.825 0 1.5-.675 1.5-1.5V9c0-.825-.675-1.5-1.5-1.5z"
                fill="#5A89FD"
            />
        </svg>
    );
};

export default memo(MobileSms);
